import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { FaRegClock } from 'react-icons/fa';
import { FaAngleRight } from 'react-icons/fa';
import { LuHeart } from 'react-icons/lu';
import { FaRegFileAlt } from 'react-icons/fa';
import { RxPencil2 } from 'react-icons/rx';
import { FaHeart } from 'react-icons/fa';
import { FiEdit2 } from 'react-icons/fi';
import { FiTrash2 } from 'react-icons/fi';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import { FaCamera, FaImage } from 'react-icons/fa';
import { getMyBookScripts, getMyBookByBookId, getTotalRecord, putMyBookScore, putMyBookScriptPage, uploadScriptImageToTmpFile, addMyBookScript, modifyMyBookScript, deleteMyBookScript } from '../api/BookcaseApi';
import { getAccessToken, getNativeWebview } from '../react-queries/queries';
import { takePicture } from '../api/native/NativeApis';
import { processApiResponse } from '../common/errorMessage';
import { getDday, formatTime, stringFrDate } from '../common/utils';
import { ownership2text, RecordType } from '../common/enums';
import LoadingOverlay from '../components/LoadingOverlay';
import { ErrorContainer, ErrorMessage } from '../components/ErrorContainer';
import { useNoobookContext } from '../context/NoobookContext';
import NupilBookHistoryPage from './NupilBookHistoryPage';
import { FaTimes } from 'react-icons/fa';



const PageWrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
`;
const BookInfoBox = styled.div`
  background: #eae8e9;
  padding: 32px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const BookInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0 8px 0;
`;
const Dday = styled.div`
  background: #636363;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;
const Title = styled.div`
  font-size: 17px;
  font-weight: 500;
  color: #222;
  margin-top: 8px;
  margin-bottom: 2px;
  padding: 0 16px 0 16px;
`;
const Author = styled.div`
  font-size: 15px;
  color: #888;
  margin-bottom: 4px;
`;
const Period = styled.div`
  font-size: 13px;
  color: #888;
  margin-bottom: 10px;
`;
const Badge = styled.span`
  background: #1976d2;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;
const InfoRow = styled.div`
  display: flex;
  gap: 18px;
  justify-content: center;
  margin-bottom: 18px;
  width: 100%;
  box-sizing: border-box;
`;
const InfoCard = styled.div`
  background: #fff;
  border: 2px solid #dedede;
  border-radius: 14px;
  flex: 1 1 0;
  min-width: 0;
  max-width: 110px;
  height: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #888;
  font-weight: 500;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
`;
const InfoValue = styled.div`
  color: #2346a9;
  font-size: 15px;
  font-weight: 700;
  margin-top: 4px;
`;
const MemoSectionBg = styled.div`
  background: #eae8e9;
  padding-bottom: 0;
`;
const MemoSection = styled.div`
  background: #fff;
  border-radius: 16px;
  margin: 0 16px 0 16px;
  padding: 20px 18px 32px 18px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
`;
const MemoHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 12px;
`;
const AddMemoBtn = styled.button`
  background: #bdbdbd;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  margin-left: 12px;
  padding: 4px 14px;
  cursor: pointer;
`;
const MemoBox = styled.div`
  background: #f5f5f5;
  border-radius: 8px;
  padding: 18px 14px;
  color: #555;
  font-size: 0.95rem;
  margin-bottom: 18px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ScriptImage = styled.img`
  max-width: 100%;
  max-height: 400px;
  border-radius: 8px;
  object-fit: contain;
  margin-bottom: 12px;
`;
const MemoActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 12px;
  padding-top: 8px;
`;
const ActionIcon = styled.button`
  background: none;
  border: none;
  color: #888;
  font-size: 14px;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: #555;
  }
`;
const Pagination = styled.div`
  text-align: center;
  color: #888;
  font-size: 15px;
  margin-top: 8px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const PaginationText = styled.span`
  color: #888;
  font-size: 13px;
  white-space: nowrap;
`;
const MemoBoxContainer = styled.div`
  position: relative;
`;
const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  ${props => props.direction === 'left' && `
    left: -18px;
  `}
  
  ${props => props.direction === 'right' && `
    right: -18px;
  `}
`;
const SeparatorBar = styled.div`
  width: 100%;
  max-width: 440px;
  height: 12px;
  background: #eae8e9;
  border-radius: 4px;
  border-top: 1px solid #fff;
  box-shadow: 0 4px 16px rgba(0,0,0,0.18);
  margin: 18px auto 32px auto;
`;
const TotalTimeBox = styled.div`
  margin-top: 8px;
  background: #244ac2;
  border-radius: 16px;
  padding: 6px 18px 6px 14px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
const TimerIcon = styled.span`
  display: flex;
  align-items: center;
  margin-right: 4px;
`;
const TotalTimeText = styled.span`
  color: #fff;
  font-size: 15px;
  font-weight: 500;
`;
const HistoryText = styled.div`
  color: #2346a9;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  margin-top: 6px;
`;
const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;
const ScoreModal = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px 20px 24px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ScoreRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 18px;
`;
const ScoreHeart = styled.span`
  cursor: pointer;
  font-size: 32px;
  color: ${props => props.selected ? '#244ac2' : '#bdbdbd'};
  transition: color 0.15s;
`;
const ModalCloseBtn = styled.button`
  background: #eee;
  color: #555;
  border: none;
  border-radius: 8px;
  padding: 6px 18px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
`;
const MemoModalOverlay = styled(ModalOverlay)``;
const MemoModal = styled(ScoreModal)`
  min-width: 320px;
`;
const MemoTextarea = styled.textarea`
  width: 100%;
  min-height: 80px;
  border: 1px solid #dedede;
  border-radius: 8px;
  padding: 10px;
  font-size: 16px;
  margin-bottom: 18px;
  resize: vertical;
  &:focus {
    border: 1px solid #dedede;
    outline: none;
  }
`;
const MemoModalBtnRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;
const MemoModalBtn = styled(ModalCloseBtn)`
  min-width: 64px;
`;
const ImageUploadArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
`;
const UploadButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;
const UploadButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  background: #f5f5f5;
  border: 2px dashed #ddd;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
  
  &:hover {
    border-color: #0057ff;
    background: #f0f8ff;
  }
`;
const ImagePreview = styled.img`
  max-width: 100%;
  max-height: 300px;
  border-radius: 8px;
  object-fit: contain;
`;

const ScriptPageModalOverlay = styled(ModalOverlay)``;
const ScriptPageModal = styled(ScoreModal)`
  min-width: 240px;
`;
const ScriptPageInput = styled.input`
  width: 30%;
  height: 40px;
  border: 1px solid #dedede;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 16px;
  margin-bottom: 18px;
  text-align: center;
  &:focus {
    border: 1px solid #244ac2;
    outline: none;
  }
`;
const ScriptPageModalBtnRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;
const ScriptPageModalBtn = styled(ModalCloseBtn)`
  min-width: 64px;
`;


const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0;
`;


const BookHistoryModal = ({bookId, onClose }) => {
  return (
    <Modal>
      <ModalHeader>
        <ModalTitle>필사 이력</ModalTitle>
        <ModalCloseButton onClick={()=>{onClose(false);}}>
          <FaTimes />
        </ModalCloseButton>
      </ModalHeader>
      <ModalContent>
        <NupilBookHistoryPage propBookId={bookId} onClose={onClose} />
      </ModalContent>
    </Modal>
  )
};



const PAGE_SIZE = 30;

export default function NupilBookRecordPage({propBookId = null, onModified = null}) {
  const { setShowBack } = useNoobookContext();

  const [scoreModalOpen, setScoreModalOpen] = useState(false);
  //const [myScore, setMyScore] = useState(0);
  const [memoModalOpen, setMemoModalOpen] = useState(false);
  //const [memoText, setMemoText] = useState("");
  const [tmpImgFileId, setTmpImgFileId] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [scriptPageModalOpen, setScriptPageModalOpen] = useState(false);
  const [scriptPageText, setScriptPageText] = useState("");
  const [currentMemoIndex, setCurrentMemoIndex] = useState(0);
  const [scripts, setScripts] = useState([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingIndex, setEditingIndex] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deletingIndex, setDeletingIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [bookData, setBookData] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalScripts, setTotalScripts] = useState(0);
  const [totalScriptTime, setTotalScriptTime] = useState(0);
  const [totalReadCnt, setTotalReadCnt] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  
  const { bookId:argBookId } = useParams();
  const [bookId, setBookId] = useState(propBookId ? propBookId : argBookId);
  const [showBookHistoryModal, setShowBookHistoryModal] = useState(false);
  //const totalScripts = scripts.length
  const navigate = useNavigate();

  useEffect(() => {
    setShowBack(true);
  }, []);

  // 초기 데이터 로드
  useEffect(() => {
    const loadInitialData = async () => {
      if (!bookId) return;
      
      setLoading(true);
      try {
        const { accessToken } = await getAccessToken();
        
        // 책 정보 로드
        const bookResponse = await getMyBookByBookId(accessToken || '', parseInt(bookId));
        const processedBookResponse = processApiResponse(bookResponse);
        
        if (!processedBookResponse.success) {
          setError(processedBookResponse.errorMessage);
          return;
        }
        
        setBookData(processedBookResponse.data);


        // 총 독서 시간 조회
        const totalResponse = await getTotalRecord(accessToken || '', parseInt(bookId), RecordType.SCRIPTING);
        const processedTotalResponse = processApiResponse(totalResponse);
        
        if (processedTotalResponse.success) {
          setTotalScriptTime(processedTotalResponse.data.totalTimeInSec || 0);
          setTotalReadCnt(processedTotalResponse.data.totalCnt || 0);
        } else {
          console.error('총 필사 시간 조회 실패:', processedTotalResponse.errorMessage);
          //setError(processedTotalResponse.errorMessage);
        }


        
        // 첫 페이지 필사 이미지 로드
        const scriptsResponse = await getMyBookScripts(accessToken || '', parseInt(bookId), 0, PAGE_SIZE);
        const processedScriptsResponse = processApiResponse(scriptsResponse);
        
        if (processedScriptsResponse.success) {
          setScripts(processedScriptsResponse.data || []);          
          setHasMore(processedScriptsResponse.page.current < processedScriptsResponse.page.last);
          setCurrentPage(processedScriptsResponse.page.current);
          setTotalScripts(processedScriptsResponse.page.total);
          
        } else {
          setError(processedScriptsResponse.errorMessage);
        }
        
      } catch (error) {
        console.error('데이터 로드 중 오류:', error);
        setError('네트워크 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    };
    
    loadInitialData();
  }, [bookId]);

  // 다음 페이지 필사 이미지 로드
  const loadMoreScripts = async () => {
    if (!hasMore || loadingMore) return;
    
    setLoadingMore(true);
    try {
      const { accessToken } = await getAccessToken();
      const nextPage = currentPage + 1;
      
      const scriptsResponse = await getMyBookScripts(accessToken || '', parseInt(bookId), nextPage, PAGE_SIZE);
      const processedScriptsResponse = processApiResponse(scriptsResponse);
      
      if (processedScriptsResponse.success) {
        const newScripts = processedScriptsResponse.data || [];
        //console.log(newScripts[0].memo);
        setScripts(prev => [...prev, ...newScripts]);
        setCurrentPage(processedScriptsResponse.page.current);
        setHasMore(processedScriptsResponse.page.current < processedScriptsResponse.page.last);
        setTotalScripts(processedScriptsResponse.page.total);
      } else {
        console.error('필사 이미지 로드 실패:', processedScriptsResponse.errorMessage);
      }
      
    } catch (error) {
      console.error('필사 이미지 로드 중 오류:', error);
    } finally {
      setLoadingMore(false);
    }
  };

  const handleScoreClick = (score) => {
    //setMyScore(score);
    setBookData(prev => ({ ...prev, score: score }));
    setTimeout(async () => {
    setScoreModalOpen(false);
      try {
        setLoading(true);
        const { accessToken } = await getAccessToken();
        // 서버에 점수 저장
        const response = await putMyBookScore(accessToken || '', parseInt(bookId), score);
        const processedResponse = processApiResponse(response);
        if (processedResponse.success && processedResponse.data) {
          setBookData(processedResponse.data);
        }
      } catch (error) {
        alert('별점 저장 중 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    }, 500);
  };
  
  const handleMemoSave = async () => {
    if (!tmpImgFileId) {
      alert('이미지를 선택해주세요.');
      return;
    }

    try {
      setLoading(true);
      const { accessToken } = await getAccessToken();
      
      // 서버에 필사 이미지 저장
      let response = null;
      if(memoModalOpen) {
        response = await addMyBookScript(accessToken || '', parseInt(bookId), tmpImgFileId);
      } else {
        response = await modifyMyBookScript(accessToken || '', scripts[editingIndex].id, tmpImgFileId);
      }
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        setMemoModalOpen(false);
        setEditModalOpen(false);
        //setMemoText("");
        setTmpImgFileId(null);
        setSelectedImage(null);
        setImagePreview(null);
        if (onModified) {
          onModified();
        }
        
        if(memoModalOpen) {
        // 저장 후 첫 페이지 fetch
          const firstPage = 0;
          const scriptsResponse = await getMyBookScripts(accessToken || '', parseInt(bookId), firstPage, PAGE_SIZE);
          const processedScriptsResponse = processApiResponse(scriptsResponse);
          if (processedScriptsResponse.success) {
            setScripts(prev => {
              const prevPages = prev.length > PAGE_SIZE ? prev.slice(PAGE_SIZE, prev.length) : [];
              return [...(processedScriptsResponse.data || []), ...prevPages];
            });
            const lastPage = Math.max(0, Math.floor(scripts.length / PAGE_SIZE) - 1);
            setCurrentPage(lastPage);
            setHasMore(lastPage < processedScriptsResponse.page.last);
            setTotalScripts(processedScriptsResponse.page.total);
            setCurrentMemoIndex(0);
          }
        } else {
          // 수정 후 현재 페이지 fetch
          const indexPage = Math.floor(editingIndex / PAGE_SIZE);
          const scriptsResponse = await getMyBookScripts(accessToken || '', parseInt(bookId), indexPage, PAGE_SIZE);
          const processedScriptsResponse = processApiResponse(scriptsResponse);
          if (processedScriptsResponse.success) {
            setScripts(prev => {
            const prevPages = prev.slice(0, indexPage * PAGE_SIZE);
            return [...prevPages, ...(processedScriptsResponse.data || [])];
          });
            const lastPage = Math.max(0, Math.floor(scripts.length / PAGE_SIZE) - 1);
            setCurrentPage(lastPage);
            setHasMore(lastPage < processedScriptsResponse.page.last);
            setTotalScripts(processedScriptsResponse.page.total);
          }
        }
      } else {
        alert('필사 이미지 저장에 실패했습니다: ' + processedResponse.errorMessage);
      }
    } catch (error) {
      console.error('필사 이미지 저장 중 오류:', error);
      alert('필사 이미지 저장 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleMemoClick = () => {
    
    setTmpImgFileId(null);
    setSelectedImage(null);
    setImagePreview(null);
    setMemoModalOpen(true);
  };

  const handleEditClick = (index) => {
    setEditingIndex(index);
    setTmpImgFileId(null);
    setSelectedImage(null);
    setImagePreview(null);
    setEditModalOpen(true);
  };


  const handleDeleteClick = (index) => {
    setDeletingIndex(index);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      setLoading(true);
      const { accessToken } = await getAccessToken();
      const scriptId = scripts[deletingIndex].id;
      await deleteMyBookScript(accessToken || '', scriptId);
      setDeleteModalOpen(false);
      // 삭제 후 현재 페이지 fetch
      const indexPage = Math.floor(deletingIndex / PAGE_SIZE);
      const scriptsResponse = await getMyBookScripts(accessToken || '', parseInt(bookId), indexPage, PAGE_SIZE);
      const processedScriptsResponse = processApiResponse(scriptsResponse);
      if (processedScriptsResponse.success) {
        setScripts(prev => {
          const prevPages = prev.slice(0, indexPage * PAGE_SIZE);
          return [...prevPages, ...(processedScriptsResponse.data || [])];
        });
        const lastPage = Math.max(0, Math.floor(scripts.length / PAGE_SIZE) - 1);
        setCurrentPage(lastPage);
        setHasMore(lastPage < processedScriptsResponse.page.last);
        setTotalScripts(processedScriptsResponse.page.total);
    // 삭제 후 현재 인덱스 조정
        setCurrentMemoIndex(Math.min(currentMemoIndex, (scripts || []).length - 1));
    }
    } catch (error) {
      alert('메모 삭제 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handlePrevMemo = () => {
    if (currentMemoIndex > 0) {
      setCurrentMemoIndex(currentMemoIndex - 1);
    }
  };

  const handleNextMemo = () => {
    if (currentMemoIndex < scripts.length - 1) {
      setCurrentMemoIndex(currentMemoIndex + 1);
      
      // 페이지 끝에 도달하면 다음 페이지 로드
      if (currentMemoIndex >= scripts.length - 3 && hasMore && !loadingMore) {
        loadMoreScripts();
      }
    }
  };

  const handleScriptPageSave = async () => {
    const pageNum = parseInt(scriptPageText);
    if (isNaN(pageNum) || pageNum < 0 || pageNum > 9999) {
      alert('올바른 페이지 수를 입력해주세요. (0-9999)');
      return;
    }

    try {
      setLoading(true);
      const { accessToken } = await getAccessToken();
      
      // 서버에 읽은 페이지 저장
      const response = await putMyBookScriptPage(accessToken || '', parseInt(bookId), pageNum);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success && processedResponse.data) {
        setBookData(processedResponse.data);
        setScriptPageModalOpen(false);
        setScriptPageText("");
        if (onModified) {
          onModified();
        }
      } else {
        alert(processedResponse.errorMessage || '읽은 페이지 저장에 실패했습니다.');
      }
    } catch (error) {
      console.error('읽은 페이지 저장 중 오류:', error);
      alert('읽은 페이지 저장 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const base64ToFile = (base64String, fileName = 'camera.jpg') => {
    let base64 = base64String;
    let mimeType = 'image/jpeg';

    if (base64String.includes(',')) {
      const parts = base64String.split(',');
      const match = parts[0].match(/:(.*?);/);
      if (match) mimeType = match[1];
      base64 = parts[1];
    }

    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    return new File([blob], fileName, { type: mimeType });
  };

  const handleCameraCapture = async () => {
    const isWebview = getNativeWebview();
    if (isWebview) {
      try {
        const response = await takePicture();
        if (response.result === 0 && response.data?.picture) {
          const base64Picture = response.data.picture;
          const dataUrl = base64Picture.startsWith('data:')
            ? base64Picture
            : `data:image/jpeg;base64,${base64Picture}`;
          const file = base64ToFile(base64Picture, 'camera.jpg');

          setSelectedImage(file);
          setImagePreview(dataUrl);
          uploadTmpFile(file);
        } else {
          alert('카메라 촬영에 실패했습니다.');
        }
      } catch (error) {
        console.error('카메라 촬영 중 오류:', error);
        alert('카메라 촬영 중 오류가 발생했습니다.');
      }
    } else {
      document.getElementById('camera-input').click();
    }
  };

  // 파일 선택 핸들러
  const handleFileSelect = async (event) => {
    
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        alert('이미지 파일만 선택할 수 있습니다.');
        return;
      }
      
      setSelectedImage(file);
      
      // 미리보기 생성
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
      
      // 자동으로 임시 업로드
      uploadTmpFile(file);
    }
  };



  // 임시 파일 업로드
  const uploadTmpFile = async (file) => {
    try {
      const { accessToken } = await getAccessToken();
     // const formData = new FormData();
     // formData.append('file', file);
      
      const response = await uploadScriptImageToTmpFile(accessToken, file);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        console.log(processedResponse.data.fileId);
        setTmpImgFileId(processedResponse.data.fileId);
      } else {
        alert('이미지 업로드에 실패했습니다: ' + processedResponse.errorMessage);
      }
    } catch (error) {
      console.error('이미지 업로드 중 오류:', error);
      alert('이미지 업로드 중 오류가 발생했습니다.');
    }
  };

  

  // 모달 닫기 시 상태 초기화
  const handleCloseModal = () => {
    setMemoModalOpen(false);
    setEditModalOpen(false);
    //setMemoText("");
    setTmpImgFileId(null);
    setSelectedImage(null);
    setImagePreview(null);
  };

  const popupBookHistory = () => {
    //navigate(`/book-history/${bookId}`);
    setShowBookHistoryModal(true);
  };

  const handleBookHistoryClose = (modified) => {
    setShowBookHistoryModal(false);
  };

  

  // 로딩 중이거나 에러가 있는 경우 처리
  if (loading) {
    return (
      <>
        <div style={{background:'#eae8e9', minHeight:'100vh'}}>
          <div style={{padding: '20px', textAlign: 'center'}}>로딩 중...</div>
        </div>
        <LoadingOverlay isLoading={loading} />
      </>
    );
  }

  if (error || !bookData) {
    return (
      <ErrorContainer>
        <ErrorMessage>{error || '책 정보를 찾을 수 없습니다.'}</ErrorMessage>
      </ErrorContainer>
    );
  }

  // API 데이터를 기존 sampleBookData 형식으로 변환
  const transformedData = {
    id: bookData.id,
    score: bookData.score,
    title: bookData.title,
    author: bookData.author + ' / ' + bookData.publisher,
    period: stringFrDate(bookData?.scriptFr??'', 'yyyy-MM-dd', '-') + ' ~ ' + stringFrDate(bookData?.scriptTo??'', 'yyyy-MM-dd', '-'),
    dday: getDday(bookData.scriptTo),
    badge: ownership2text(bookData.ownership),
    cover: bookData.cover,
    scriptPage: bookData.scriptPage || 0,
    pageNum: bookData.pageNum || 0
  };

  return (
    <>
      <PageWrapper>
        <BookInfoBox>
          <BookInfoContent>
            <Title>{transformedData.title}</Title>
            <Period>{transformedData.period}</Period>
            <TotalTimeBox>
              <TimerIcon><FaRegClock size={18} color="#fff" /></TimerIcon>
              <TotalTimeText>총 필사 시간 {formatTime(totalScriptTime)}</TotalTimeText>
            </TotalTimeBox>
            <HistoryText
              onClick={() => /*navigate(`/book-history-nupil/${bookId}`)*/popupBookHistory()}
            >
              <FaAngleRight size={10} color="#2346a9" style={{marginRight:4, verticalAlign:'middle'}} />
              필사 이력 {totalReadCnt}회
            </HistoryText>
          </BookInfoContent>
          <SeparatorBar />
          <InfoRow>
            <InfoCard onClick={() => setScoreModalOpen(true)}>
              <LuHeart size={22} color="#898989" style={{marginBottom:4}} />
              <div>내 별점</div>
              <InfoValue>{transformedData.score}</InfoValue>
            </InfoCard>
            <InfoCard onClick={() => {
              setScriptPageText(transformedData.scriptPage.toString());
              setScriptPageModalOpen(true);
            }}>
              <FaRegFileAlt size={22} color="#898989" style={{marginBottom:4}} />
              <div>필사한 페이지</div>
              <InfoValue>{transformedData.scriptPage}p</InfoValue>
            </InfoCard>
            <InfoCard onClick={handleMemoClick}>
              <RxPencil2 size={22} color="#898989" style={{marginBottom:4}} />
              <div>필사</div>
              <InfoValue>{totalScripts}장</InfoValue>
            </InfoCard>
          </InfoRow>
        </BookInfoBox>
        {scoreModalOpen && (
          <ModalOverlay>
            <ScoreModal>
              <div style={{fontWeight:700, fontSize:18, marginBottom:16}}>별점 선택</div>
              <ScoreRow>
                {[1,2,3,4,5].map((score) => (
                  <ScoreHeart key={score} selected={transformedData.score >= score} onClick={() => handleScoreClick(score)}>
                    {transformedData.score >= score ? <FaHeart /> : <LuHeart />}
                  </ScoreHeart>
                ))}
              </ScoreRow>
              <ModalCloseBtn onClick={()=>setScoreModalOpen(false)}>닫기</ModalCloseBtn>
            </ScoreModal>
          </ModalOverlay>
        )}
        {(memoModalOpen || editModalOpen) && (
          <MemoModalOverlay>
            <MemoModal>
              <div style={{fontWeight:700, fontSize:18, marginBottom:16}}>필사 이미지 업로드</div>
              <ImageUploadArea>
                {!imagePreview ? (
                  <UploadButtons>
                    <UploadButton onClick={handleCameraCapture}>
                      <FaCamera size={32} color="#0057ff" />
                      <span style={{fontSize: 14, color: '#666'}}>카메라로 촬영</span>
                    </UploadButton>
                    <UploadButton onClick={() => document.getElementById('file-input').click()}>
                      <FaImage size={32} color="#0057ff" />
                      <span style={{fontSize: 14, color: '#666'}}>파일에서 선택</span>
                    </UploadButton>
                  </UploadButtons>
                ) : (
                  <div style={{textAlign: 'center'}}>
                    <ImagePreview src={imagePreview} alt="미리보기" />
                    <div style={{marginTop: 12, fontSize: 14, color: '#666'}}>
                      {selectedImage?.name}
                    </div>
                    <button 
                      onClick={() => {
                        setSelectedImage(null);
                        setImagePreview(null);
                        setTmpImgFileId(null);
                      }}
                      style={{
                        marginTop: 8,
                        background: '#f0f0f0',
                        border: 'none',
                        borderRadius: 6,
                        padding: '6px 12px',
                        fontSize: 12,
                        color: '#666',
                        cursor: 'pointer'
                      }}
                    >
                      다시 선택
                    </button>
                  </div>
                )}
              </ImageUploadArea>
              <MemoModalBtnRow>
                <MemoModalBtn onClick={handleCloseModal}>취소</MemoModalBtn>
                <MemoModalBtn 
                  style={{
                    background: tmpImgFileId ? '#244ac2' : '#ccc', 
                    color: '#fff',
                    cursor: tmpImgFileId ? 'pointer' : 'not-allowed'
                  }} 
                  onClick={tmpImgFileId ? handleMemoSave : undefined}
                >
                  저장
                </MemoModalBtn>
              </MemoModalBtnRow>
              
              {/* 숨겨진 input 요소들 */}
              <input
                id="camera-input"
                type="file"
                accept="image/*"
                capture="camera"
                onChange={handleFileSelect}
                style={{ display: 'none' }}
              />
              <input
                id="file-input"
                type="file"
                accept="image/*"
                onChange={handleFileSelect}
                style={{ display: 'none' }}
              />
            </MemoModal>
          </MemoModalOverlay>
        )}
        {scriptPageModalOpen && (
          <ScriptPageModalOverlay onClick={()=>{
            setScriptPageModalOpen(false);
            setScriptPageText("");
          }}>
            <ScriptPageModal onClick={e => e.stopPropagation()}>
              <div style={{fontWeight:700, fontSize:18, marginBottom:16}}> 필사한 페이지</div>
              <ScriptPageInput
                type="number"
                value={scriptPageText}
                onChange={e => {
                  const value = e.target.value;
                  //if (value.length <= 4 
                    //&& !isNaN(value) 
                    //&& parseInt(value) >= 0) {
                    setScriptPageText(value);
                  //}
                }}
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    handleScriptPageSave();
                  }
                }}
                placeholder="페이지 수를 입력하세요"
                min="0"
                max="9999"
                autoFocus
              />
              <ScriptPageModalBtnRow>
                <ScriptPageModalBtn onClick={()=>{
                  setScriptPageModalOpen(false);
                  setScriptPageText("");
                }}>취소</ScriptPageModalBtn>
                <ScriptPageModalBtn style={{background:'#244ac2', color:'#fff'}} onClick={handleScriptPageSave}>저장</ScriptPageModalBtn>
              </ScriptPageModalBtnRow>
            </ScriptPageModal>
          </ScriptPageModalOverlay>
        )}
        <MemoSectionBg>
          <MemoSection>
            <MemoHeader>
              필사 이미지
              <AddMemoBtn onClick={handleMemoClick}>+ 남기기</AddMemoBtn>
            </MemoHeader>
            {scripts.length > 0 ? (
              <>
                <MemoBoxContainer>
            <MemoBox>
                    {scripts[Math.min(currentMemoIndex, scripts.length - 1)].imageUrl && (
                      <ScriptImage 
                        src={scripts[Math.min(currentMemoIndex, scripts.length - 1)].imageUrl} 
                        alt="필사 이미지" 
                      />
                    )}
              <MemoActions>
                <ActionIcon onClick={() => handleEditClick(currentMemoIndex)}>
                  <FiEdit2 size={16} color="#bbb" />
                </ActionIcon>
                <ActionIcon onClick={() => handleDeleteClick(currentMemoIndex)}>
                  <FiTrash2 size={16} color="#bbb" />
                </ActionIcon>
              </MemoActions>
            </MemoBox>
                  <ArrowButton 
                    direction="left" 
                    onClick={handlePrevMemo}
                    disabled={currentMemoIndex === 0}
                  >
                    <IoChevronBack size={20} color="#666" />
                  </ArrowButton>
                  <ArrowButton 
                    direction="right" 
                    onClick={handleNextMemo}
                    disabled={currentMemoIndex === totalScripts - 1}
                  >
                    <IoChevronForward size={20} color="#666" />
                  </ArrowButton>
                </MemoBoxContainer>
            <Pagination>
              <PaginationText>{currentMemoIndex + 1} / {totalScripts}</PaginationText>
            </Pagination>
              </>
            ) : (
              <div style={{textAlign: 'center', color: '#888', padding: '40px 0'}}>
                아직 필사 이미지가 없습니다.
              </div>
            )}
          </MemoSection>
        </MemoSectionBg>
       
        {deleteModalOpen && (
          <MemoModalOverlay>
            <MemoModal>
              <div style={{fontWeight:700, fontSize:18, marginBottom:16}}>필사 이미지 삭제</div>
              <div style={{color:'#555', fontSize:15, marginBottom:20, textAlign:'center'}}>
                필사 이미지를 삭제하시겠습니까?
              </div>
              <MemoModalBtnRow>
                <MemoModalBtn onClick={()=>setDeleteModalOpen(false)}>취소</MemoModalBtn>
                <MemoModalBtn style={{background:'#e74c3c', color:'#fff'}} onClick={handleDeleteConfirm}>삭제</MemoModalBtn>
              </MemoModalBtnRow>
            </MemoModal>
          </MemoModalOverlay>
        )}
      </PageWrapper>
      {showBookHistoryModal && (
        <BookHistoryModal bookId={bookId} onClose={handleBookHistoryClose} />
      )}
      {loadingMore && <LoadingOverlay isLoading={loadingMore} />}
    </>
  );
} 